import { PcrBackupConstants } from './pcrBackup.constants'
import { initialPcrBackupState, IPcrBackupAction, IPcrBackupState } from './pcrBackup.types'

export { initialPcrBackupState }

export function pcrBackupReducer(
  state: IPcrBackupState = initialPcrBackupState,
  action: IPcrBackupAction
): IPcrBackupState {
  switch (action.type) {
    case PcrBackupConstants.SET_METADATA:
      if (!action.metadata) return state
      return { ...action.metadata }
    case PcrBackupConstants.RESET:
      return { ...initialPcrBackupState }
    default:
      return state
  }
}
